import { donations } from './donations';

const div = document.querySelector(".wp-block-tsd-plot");
div.append(donations);


